import request from '@/request';

// 取得指定的Batch
export function singletask(type) {
  return request({
    url: `/meta/${type}/to_label`,
    method: 'get',
  });
}

// 更新任務
export function updatetask(data) {
  return request({
    url: `/meta/${data.type}`,
    method: 'post',
    data: {
      name: data.name,
      label_alert_type: data.label_alert_type,
      is_uncertain:data.is_uncertain,
      is_skip: data.is_skip,
    },
  });
}

// 取得指定的圖片 (透過上下鍵)
export function getsingle(data) {
  return request({
    url: `/meta/${data.type}/${data.name}`,
    method: 'get',
  });
}

// audio label info

export function audiolabel(data) {
  return request({
    url: '/meta/audio',
    method: 'post',
    data: {
      name: data.name,
      is_skip: data.skip,
      is_uncertain:data.is_uncertain,
      segments: data.segments,
    },
  });
}

export function dataToSleepOcclusion(data) {
  return request({
    url: '/meta/sleep_occl',
    method: 'post',
    data: {
      name: data.name,
      landmarks: data.landmarks,
      occl_state: data.occl_state,
      cover_state: data.cover_state,
      eye_open: data.eye_open,
      has_hand: data.has_hand,
      has_pacifier: data.has_pacifier,
      is_skip: data.is_skip,
      is_uncertain:data.is_uncertain,
      bbox_head: data.bbox_head,
    },
  });
}

export function getImgOrAudioWithToken(data) {
  return request({
    url: `/data/${data.BatchType}/${data.BatchDate}/${data.ImgOrAudioName}`,
    method: 'get',
    responseType: 'blob',
  });
}

export function dataToSleepDetection(data) {
  return request({
    url: '/meta/sleep_detection',
    method: 'post',
    data: {
      name: data.name,
      is_skip: data.is_skip,
      is_uncertain:data.is_uncertain,
      label_bboxes: data.label_bboxes,
    },
  });
}

export function getLabelMetas(batch_type, email, date, count) {
  return request({
    url: `metas/${batch_type}/random_pick?count=${count}&batch_date=${date}&account=${email}`,
    method: 'get',
  });
}
